import { setSession } from '@back-office/core';
import { LoginRequest, LoginResponse, postLogin } from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { Self } from '../common';

export function* loginRequest(
  self: Self,
  body: LoginRequest
): Generator<Promise<FlowReturn<LoginResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postLogin(body);
    const { data, status } = (response as LoginResponse).data;
    if (status.code === 1000) {
      setSession({ users: data.mids });
      return Promise.resolve(data);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    self.auth.reset();
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default loginRequest;
